import React from "react";

const ApplicationDetailCard = ({
  last_name,
  first_name,
  phone,
  email,
  community,
  unit_rent,
  created_at,
  authorized_at,
  docs_received_at,
  completed_at,
}) => {
  return (
    <div className="card custom-card overflow-hidden">
      <div className="card-body p-0">
        <div className="d-sm-flex align-items-top p-4 border-bottom border-block-end-dashed">
          <div>
            <div className="avatar avatar-xxl bg-primary avatar-rounded me-3">
              AA
            </div>
          </div>
          <div className="flex-fill main-profile-info">
            <h6 className="fw-semibold mb-1 ">{`${first_name} ${last_name}`}</h6>
            <div className="badge bg-success">Primary</div>
            <div className="fs-14">{email}</div>
            <div className=" fs-14">{phone}</div>
          </div>
        </div>

        <div className="p-4 border-bottom border-block-end-dashed">
          <div className="row">
            <div className="col">
              <div className="fs-14 fw-bold mb-1">Community</div>
            </div>
            <div className="col-8">
              <div className="fw-semibold">{community?.name}</div>
              <div>{community?.address}</div>
            </div>
          </div>
        </div>

        <div className="p-4 border-bottom border-block-end-dashed">
          <div className="row">
            <div className="col">
              <div className="fs-14 fw-bold mb-1">Unit Rent</div>
            </div>
            <div className="col-8">
              <div className="">
                {`$${unit_rent?.toLocaleString()}`} / month
              </div>
            </div>
          </div>
        </div>

        <div className="p-4 border-bottom border-block-end-dashed">
          <div className="row">
            <div className="col">
              <div className="fs-14 fw-bold mb-1">Guarantor</div>
            </div>
            <div className="col-8">
              <div className="">
                Daniel Ramirez
              </div>
            </div>
          </div>
        </div>

        <div className="p-4 border-bottom border-block-end-dashed">
          <div className="row">
            <div className="col">
              <div className="fs-14 fw-bold mb-1">Status</div>
            </div>
            <div className="col-8">
              <div className="row mb-1 text-muted op-7">
                <div className="col">Submitted:</div>
                <div className="col text-dark fw-semibold">
                  {created_at || "N/A"}
                </div>
              </div>
              <div className="row mb-1 text-muted op-7">
                <div className="col">Authorized:</div>
                <div className="col text-dark fw-semibold">
                  {authorized_at || "N/A"}
                </div>
              </div>
              <div className="row mb-1 text-muted op-7">
                <div className="col">Docs Received:</div>
                <div className="col text-dark fw-semibold">
                  {docs_received_at || "N/A"}
                </div>
              </div>
              <div className="row mb-1 text-muted op-7">
                <div className="col">Completed:</div>
                <div className="col text-dark fw-semibold">
                  {completed_at || "N/A"}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="p-4 border-bottom ">
        <div className="row">
          <div className="col">
            <div className="fs-14 fw-bold mb-1">Documents</div>
          </div>
          <div className="col-8">
            <div className="alert alert-success ">
              <span className="text-success fw-semibold  py-1">
                Photo ID
              </span>
              <i className="float-end fs-16 bi bi-check-lg" />
            </div>

            <div className="alert alert-success ">
              <span className="text-success fw-semibold  py-1">
                Pay Stubs
              </span>
              <i className="float-end fs-16 bi bi-check-lg" />
            </div>

            <div className="alert alert-danger ">
              <span className="text-danger fw-semibold  py-1">
                Bank Statements
              </span>
              <i className="float-end fs-16 bi bi-x" />
            </div>
          </div>
        </div>
        
      </div> */}
      </div>
    </div>
  );
};

ApplicationDetailCard.propTypes = {};

export default ApplicationDetailCard;
